import React from 'react';
import styled from 'styled-components';
import Modal from '../../containers/common/Modal';

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  display: flex;
  align-items: flex-end;
  justify-content: center;
`;
const Sheet = styled.div`
  width: 100%;
  max-width: 440px;
  background: linear-gradient(180deg, #fad4e4 0%, #ffffff 58%);
  border-radius: 24px 24px 0 0;
  padding: 40px 24px 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
// Wraps an inline <svg> so the icon needs no network request.
const IconWrap = styled.div`
  width: 48px;
  height: 48px;
  margin-bottom: 20px;

  svg {
    width: 100%;
    height: 100%;
    display: block;
  }
`;
const Text = styled.div`
  color: #000000;
  font-family: var(--font-primary), 'Inter', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  margin-bottom: 24px;
`;
const Cta = styled.button`
  width: 100%;
  background: ${(p) => p.bg || 'var(--maroon, #97144d)'};
  color: #ffffff;
  font-family: var(--font-primary), 'Inter', sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 1.4;
  border: none;
  border-radius: 12px;
  padding: 16px;
  cursor: pointer;
`;

export default function NudgeModal({ modal, icon, onCta, onClose }) {
  if (!modal) return null;
  return (
    <Modal>
      <Backdrop data-testid="nudge-modal-backdrop" onClick={onClose}>
        <Sheet onClick={(e) => e.stopPropagation()}>
          {icon ? <IconWrap aria-hidden="true">{icon}</IconWrap> : null}
          {modal.text ? <Text>{modal.text}</Text> : null}
          <Cta
            data-testid="nudge-modal-cta"
            bg={modal.ctaColorCode}
            onClick={onCta}
          >
            {modal.ctaLabel || 'Continue'}
          </Cta>
        </Sheet>
      </Backdrop>
    </Modal>
  );
}
